/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {h} from 'preact';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import appReducer from './reducers';
import PropTypes from 'prop-types';
import Player from './components/Player.jsx';
import {Provider} from 'react-redux';
import stateLoggingDecorator from './util/stateLoggingDecorator';

let store;

if (window.location.search.includes('debug-video-player')) {
  store = createStore(stateLoggingDecorator(appReducer), applyMiddleware(thunk));
} else {
  store = createStore(appReducer, applyMiddleware(thunk));
}

const VideoPlayer = (props) => (
  <Provider store={store}>
    <Player {...props} />
  </Provider>
);

VideoPlayer.defaultProps = {
  id: '',
  className: '',
  style: {},
  autoPlay: true,
  playsInline: true,
  defaultAudioEnabled: true,
  defaultVideoEnabled: true,
  storeLocalStateKey: '',
  viewConfig: {},
  stream: null
};

VideoPlayer.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  autoPlay: PropTypes.bool,
  playsInline: PropTypes.bool,
  defaultAudioEnabled: PropTypes.bool,
  defaultVideoEnabled: PropTypes.bool,
  storeLocalStateKey: PropTypes.string,
  viewConfig: PropTypes.object,
  stream: PropTypes.object
};

export default VideoPlayer;